import { FC } from 'react';

import { useFindAllServiceNodes } from '../hooks/useServiceNodes';

export const ServiceNodesProvider: FC = () => {
  useFindAllServiceNodes();

  return null;
};
